import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import EmblaCarousel from 'embla-carousel';


// Alpine plugins

Alpine.plugin(focus);


// Sliders

window.initSlider = () => ({
    embla: null,
    canScrollPrev: false,
    canScrollNext: true,
    init() {
        const plugins = [];
        const options = {
            align: 'start',
            startIndex: parseInt(this.$refs.embla.dataset.startSnap) || 0,
            loop: this.$refs.embla.dataset.loop === 'true',
        };

        // if (this.$refs.embla.dataset.autoscroll === 'true') {
        //     plugins.push(AutoScroll({
        //         stopOnInteraction: false,
        //         stopOnMouseEnter: true,
        //         speed: 1,
        //     }));
        //     options.loop = true;
        // }

        this.embla = EmblaCarousel(this.$refs.embla, options, plugins);

        const onSelect = () => {
            this.canScrollPrev = this.embla.canScrollPrev();
            this.canScrollNext = this.embla.canScrollNext();

            const selectedSnap = this.embla.selectedScrollSnap();
            const slideNodes = this.embla.slideNodes();

            slideNodes.forEach((slide, index) => {
                slide.classList.toggle('active', index === selectedSnap);
            });

            const gallerySliderButtons = this.$refs.embla.closest('section').querySelectorAll('.gallery-slider-button');

            gallerySliderButtons.forEach((button, index) => {
                button.classList.toggle('active', index === selectedSnap);
            });
        };

        this.embla.on('select', onSelect);
        onSelect();
    },
    scrollNext() {
        this.embla.scrollNext();
    },
    scrollPrev() {
        this.embla.scrollPrev();
    },
});


// Start Alpine

Alpine.start();